export default "__VITE_ASSET__53C8hegE__"